module.exports = __webpack_public_path__ + "images/emoji/woman.bd1df31e34154e1789d5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/woman.png
// module id = o+lo
// module chunks = 24